"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCourseEvaluate = addCourseEvaluate;
exports.courseInfoStudent = exports.courseInfoNotice = exports.courseDesign = void 0;
exports.logout = logout;
exports.myCollection = void 0;
exports.passLogin = passLogin;
exports.recommendList = exports.reception = void 0;
exports.studyDetail = studyDetail;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 查询推荐课程信息列表
 */
var recommendList = exports.recommendList = function recommendList(query) {
  return _api.default.request({
    url: '/system/recommend/web/list',
    method: 'get',
    params: query
  });
};
// 登录方法
function passLogin(token) {
  return _api.default.request({
    url: '/auth/passLogin',
    headers: {
      isToken: false
    },
    method: 'get',
    params: {
      token: token
    }
  });
}
// 退出方法
function logout(token) {
  return _api.default.request({
    url: '/auth/logout?token=' + token,
    method: 'delete'
  });
}
/**
 * 描述 前台获取开课信息详细信息
 */
var reception = exports.reception = function reception(id) {
  return _api.default.request({
    url: "/teacher/courseInfo/reception/".concat(id),
    method: 'get'
  });
};

/**
 * 描述 查询课程公告列表
 */
var courseInfoNotice = exports.courseInfoNotice = function courseInfoNotice(query) {
  return _api.default.request({
    url: "/teacher/courseInfoNotice/list",
    method: 'get',
    params: query
  });
};

/**
 * 描述 查询课程设计列表
 */
var courseDesign = exports.courseDesign = function courseDesign(query) {
  return _api.default.request({
    url: "/teacher/courseDesign/list",
    method: 'get',
    params: query
  });
};

/**
 * 描述 新增学习空间-新增我的收藏
 */
var myCollection = exports.myCollection = function myCollection(data) {
  return _api.default.request({
    url: "/teacher/myCollection",
    method: 'post',
    data: data
  });
};

/**
 * 描述 新增学习空间-加入课程
 */
var courseInfoStudent = exports.courseInfoStudent = function courseInfoStudent(data) {
  return _api.default.request({
    url: "/teacher/courseInfoStudent",
    method: 'post',
    data: data
  });
};

// 课件总进度
function studyDetail(query) {
  return _api.default.request({
    url: '/teacher/courseInfo/studyDetail',
    method: 'get',
    params: query
  });
}
// 新增课程评价
function addCourseEvaluate(data) {
  return _api.default.request({
    url: '/teacher/courseInfoEvaluation',
    method: 'post',
    data: data
  });
}